module.exports = __webpack_public_path__ + "img/beach.e065bd1a.jpeg";